import {SolicitacaoQuickFixInfoList} from "@components/solicitacoes/solicitacao/SolicitacaoQuickFixInfo.tsx";
import {useApi} from "@contexts/hooks/api/useApi.ts";
import {_SolicitacoesEndpoints} from "@localization/siteMap/endpoints/_SolicitacoesEnpoints.ts";
import {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {fullWidth} from "@models/helpers.ts";
import {ISolicitacaoQuickFix} from "@models/solicitacoes/ISolicitacaoQuickFix.ts";
import {Grid} from "@mui/material";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {DefaultPagination} from "@shared/specialComponents/DefaultPagination.tsx";
import {useEffect, useState} from "react";

export interface QuickFixesPageProps {
    solicitacaoId: number;
    status?: 'pendente' | 'aprovado' | 'rejeitado';
    onAction?: (s: ISolicitacaoQuickFix) => void
}

export function QuickFixesPage(props: QuickFixesPageProps) {
    const {solicitacaoId} = props;
    const {Get} = useApi()

    const [pagination, setPagination] = useState<IPagination>({page: 1, pageSize: 10});
    const [quickFixes, setQuickFixes] = useState<ISolicitacaoQuickFix[]>([]);
    useEffect(() => {
        Get(_SolicitacoesEndpoints.GetQuickFixes({solicitacaoId: [solicitacaoId]}, pagination)).then(x => {
            if (x.hasData) {
                setQuickFixes(x.items)
                setPagination(x.pagination);
            }
        })
    }, [solicitacaoId, pagination.page]);

    return (
        <DefaultContainer size="max" sx={{...fullWidth}}>
            <DefaultPagination pagination={pagination} setPagination={setPagination}/>
            {/*<Grid container>*/}
            {quickFixes.map(x => {
                return (<Grid size={12}>
                    <SolicitacaoQuickFixInfoList value={x} onUpdate={(x) => {

                        if (props.onAction) props.onAction(x);
                    }}/>
                </Grid>)
            })}
            <DefaultPagination pagination={pagination} setPagination={setPagination}/>
            {/*</Grid>*/}
        </DefaultContainer>
    );
}